/**
 *
 * Asynchronously loads the component for PresentAddPage
 *
 */

import { lazyLoad } from 'utils/loadable';

export const PresentAddPage = lazyLoad(
  () => import('./index'),
  module => module.PresentAddPage,
);
